<template>
  <div class="vali-list-mini">
    <div v-if="title" class="vali-list-mini__title">{{ title }}</div>

    <div class="vali-list-mini__box">
      <div v-if="sessions.length === 0" class="vali-list-mini__empty">
        {{ emptyText }}
      </div>

      <div v-else class="vali-list-mini__cards">
        <ValidationMiniCard
          v-for="(session, index) in sessions"
          :key="getSessionKey(session, index)"
          :session="session"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import ValidationMiniCard from '@/components/ValidationPage/ValidationMiniCard.vue';

const props = defineProps({
  sessions: {
    type: Array,
    default: () => [],
  },
  title: {
    type: String,
    default: '',
  },
  emptyText: {
    type: String,
    default: 'No validation sessions.',
  },
});

function getSessionKey(session, index) {
  return (
    session?.id
    || session?.val_session_id
    || session?.validate_session_id
    || session?.name
    || `session-${index}`
  );
}
</script>

<style lang="scss" scoped>
.vali-list-mini {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-height: 0;
  height: 100%;
}

.vali-list-mini__title {
  font-size: 0.88rem;
  font-weight: 700;
  color: var(--body-text-color-secondary);
}

.vali-list-mini__box {
  flex: 1 1 auto;
  min-height: 0;
  border: none;
  border-radius: 0;
  background: transparent;
  padding: 0;
  overflow-y: auto;
}

.vali-list-mini__empty {
  font-size: 0.84rem;
  color: #6b7280;
  padding: 4px;
}

.vali-list-mini__cards {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
</style>
